import { useEffect, useState } from 'react'

// Below this the sidebar menu no longer fits beside its footer. Antd takes a
// size as a prop, so the answer is read here and not in the stylesheet.
export const SHORT_VIEWPORT = '(max-height: 800px)'

type Listener = (event: MediaQueryListEvent) => void

const query = () => window.matchMedia?.(SHORT_VIEWPORT)

// Safari before 14 and the WebView of an old Android carry the deprecated
// listener only, and so does jsdom.
const subscribe = (media: MediaQueryList, listener: Listener) => {
  if (media.addEventListener) {
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }

  media.addListener(listener)

  return () => media.removeListener(listener)
}

export const useShortViewport = (): boolean => {
  const [short, setShort] = useState(() => query()?.matches ?? false)

  useEffect(() => {
    const media = query()
    if (!media) return

    return subscribe(media, (event) => setShort(event.matches))
  }, [])

  return short
}

export default useShortViewport
